// extracted by mini-css-extract-plugin
export var checkmark = "checkbox-module--checkmark--a00bc";
export var cookieCheckbox = "checkbox-module--cookieCheckbox--d1c5e";
export var disableCursor = "checkbox-module--disableCursor--6ed8d";
export var grey = "checkbox-module--grey--e817b";
export var input = "checkbox-module--input--aef86";
export var label = "checkbox-module--label--33a88";
export var rightAlign = "checkbox-module--rightAlign--7b766";
export var spanStyleForArabicLang = "checkbox-module--spanStyleForArabicLang--677d6";